import Vue from "vue"; // eslint-disable-line
import LazyHydrate from "vue-lazy-hydration"; // eslint-disable-line
import container from "~/components/container.vue";
import goPicture from "~/components/goPicture.vue";
const components = { LazyHydrate, container, goPicture };

Object.entries(components).forEach(([name, component]) => {
	Vue.component(name, component);
});
